"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fieldWithoutFeedback = {
    dirty: false,
    errors: new Set(),
    warnings: new Set(),
    infos: new Set(),
    validationMessage: ''
};
exports.default = fieldWithoutFeedback;
//# sourceMappingURL=fieldWithoutFeedback.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-form-with-constraints/lib/fieldWithoutFeedback.js
// module id = 443
// module chunks = 0